export default __webpack_public_path__ + "static/media/tata.72526acf.svg";